export default "__VITE_ASSET__c5a00075__"